import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const customId = "custom-id-yes";

export const listCategories = createAsyncThunk(
  "categories/listCategories",
  async (_, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();

    try {
      const { data } = await Axios.get(`${BASE_URL}/category`, {
        headers: {
          authorization: `Bearer ${userInfo.data.accessToken}`,
        },
      });
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);
export const createCategory = createAsyncThunk(
  "categories/createCategory",
  async (category, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();

    try {
      const { data } = await Axios.post(
        `${BASE_URL}/category/create`,
        category,
        {
          headers: {
            authorization: `Bearer ${userInfo.data.accessToken}`,
          },
        }
      );
      toast.success("Category created successfully", {
        toastId: customId,
      });
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (category, { rejectWithValue, getState }) => {
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      const { data } = await Axios.post(
        `${BASE_URL}/category/update?category_id=${category.id}`,
        category.data,
        {
          headers: {
            authorization: `Bearer ${userInfo.data.accessToken}`,
          },
        }
      );
      toast.success("Category updated successfully", {
        toastId: customId,
      });
      return data;
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  loading: false,
  error: false,
  categories: [],
  category: {},
  categoryDeleteSuccess: false,
  categoryUpdateSuccess: false,
  categoryCreateSuccess: false,
};

export const categorySlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    resetCategory: (state) => {
      state.loading = false;
      state.categoryDeleteSuccess = false;
      state.categoryUpdateSuccess = false;
      state.categoryCreateSuccess = false;
    },
  },
  extraReducers: {
    [listCategories.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [listCategories.fulfilled]: (state, action) => {
      state.loading = false;
      state.categories = action?.payload;
    },
    [listCategories.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [createCategory.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [createCategory.fulfilled]: (state, action) => {
      state.loading = false;
      state.category = action?.payload;
    },
    [createCategory.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
    [updateCategory.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [updateCategory.fulfilled]: (state, action) => {
      state.loading = false;
      state.category = action?.payload;
    },
    [updateCategory.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { reducer, actions } = categorySlice;
export const { resetCategory } = actions;

export default reducer;
